export default {
  costConstitute: {
    constituteType: '类型',
    groupNo: '物料分类编码',
    goodsNo: '料号',
    goodsName: '品名',
    constituteNo: '成本构成编号',
    constituteName: '成本构成名称',
    goodsType: '类型',
    groupName: '物料分类名称',
    spec: '规格',
    tableTitle: '成本构成列表',
    dialogTitle: '添加项',
    seq: '顺序号',
    costNo: '构成项',
    costName: '构成项名称'
  },
  costItem: {
    costNo: '编号',
    costName: '成本项名称',
    remarks: '备注'
  },
  approval: {
    searchPlaceholder: '请输入流程名称查询',
    streamName: '流程名称',
    defaultSign: '默认标识',
    default: '默认',
    undefault: '非默认',
    info: '用户信息',
    addinfo: '添加元素',
    loginName: '用户编码',
    name: '用户名称',
    dialogPlaceholder: '请输入用户名或姓名进行查询',
    searchNo: '工号',
    searchName: '姓名',
    signY: '已默认',
    signN: '非默认'
  },
  enquiry: {
    inquiryType: '询价类型',
    dateTimeRange: '发布时间',
    dateTimeRange1: '报价截止时间',
    inquiryName: '询价项目',
    adddate: '创建时间',
    releaseTime: '发布时间',
    quoteEndTime: '报价截止时间',
    quoteCount: '已报价供应商',
    inviteCount: '邀请报价供应商',
    inquiryStatus: '询价状态',
    operation: {
      publish: '发布',
      edit: '编辑',
      copy: '复制',
      look: '查看报价',
      revoke: '撤销询价'
    },
    publishConfirm: '是否发布询价单？',
    revokeConfirm: '是否撤销询价单？',
    disabledEditor: '只有询价状态为待发布能编辑!',
    purOfficeNo: '采购中心',
    formTitles: {
      enquiryProduct: '询价产品',
      purchaseClaim: '采购要求',
      supplierClaim: '对供应商要求',
      privacy: '询价方式及隐私'
    },
    selectGoodsTitle: '选择物料',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    unitNo: '单位',
    qty: '采购数量',
    technologyNo: '工艺编号',
    technologyName: '工艺名称',
    minPurchaseQty: '最小起订量',
    minPackQty: '最小包装量',
    stockUpDays: '备货周期(天)',
    acceptanceCriteria: '验收标准',
    quoteUpperLimit: '报价上限',
    quoteLowerLimit: '报价下限',
    addBatchGoods: '批量添加',
    addTimeGoods: '临时添加',
    inBatchesInquiryList: '分量报价',
    inBatchesInquiryListTip: {
      noValue: '分量报价不能为空，请输入',
      number: '分量报价最小值大于最大值，请检查',
      oldNumber: '分量报价的最小值要大于上一行的最大值，请检查'
    },
    costConstituteList: '成本构成',
    costConstituteListTip: {
      noValue: '成本构成不能为空，请输入',
      codeRepeat: '您所选的{code}重复，请检查',
      nameRepeat: '您输入的{name}重复，请检查'
    },
    goodsFileList: '附件',
    uploadBtnName: '{n}个附件',
    dialogTitle: '上传文件',
    file: '附件',
    inquirySelect: '报价选择',
    inquirySelectOptions: ['分量报价', '无需报价', '由供应商报价'],
    addBatchesInquiryList: '批量添加分量报价',
    minQty: '最小值',
    maxQty: '最大值',
    addCostConstituteList: '批量添加成本构成',
    constituteNo: '成本项',
    displayPurchaseSign: '是否显示最小起订量，最小包装量，验收标准',
    fixedPriceSign: '是否限价',
    supplierInfo: '由供应商填写分量报价信息',
    deliveryDays: '交期天数',
    expectReceiptTime: '期望收货时间',
    receiptAreaId: '收货地址',
    receiptAddressDetail: '详细地址',
    validPriceStart: '价格有效期-起',
    validPriceEnd: '价格有效期-止',
    purchaseType: '采购类型',
    payTermsNo: '付款条件',
    currencyNo: '币种',
    taxTypeNo: '税种',
    taxRateSign: '是否含税',
    taxRateSignOptions: ['含税', '不含税'],
    taxRate: '税率(%)',
    quoteRequire: {
      label: '报价要求',
      containFreightSign: '报价包含运费',
      partItemSign: '允许对询价单部分物料',
      modifyQtySign: '可以修改数量'
    },
    txTermsNo: '交易条件',
    invoiceType: '发票种类',
    operatingAddress: '经营地址',
    registeredCapital: '注册资金/(万)',
    secrecyQuoteSign: '保密协议',
    secrecyQuoteSignTip: '需供应商签署保密协议才能查看详情',
    licenceRequire: {
      label: '证照要求',
      certificateUnificationSign: '三/五证合一',
      businessLicenseSign: '营业执照',
      taxRegistrationSign: '税务登记证',
      organizationCodeSign: '组织机构代码证',
      statisticalRegistrationSign: '统计等级证',
      socialInsuranceRegisterSign: '社会保险登记证'
    },
    inquiryFileList: '附件',
    additionalExplanation: '补充说明',
    enquiryWay: {
      label: '询价方式',
      publicInquirySign: '公开询价',
      designatedSupplierSign: '指定供应商'
    },
    inviteSuppliersOutList: '邀请非平台内的供应商',
    inviteSuppliersList: '指定供应商报价（发布完成后，也可在询价单管理中邀请报价）',
    cardItem: {
      dialogTitle: '非平台内的供应商',
      supOfficeName: '供应商名称',
      contactName: '联系人：',
      contactPhone: '联系电话：',
      contactEmail: '邮箱：'
    },
    inviteSuppliersListDialog: {
      dialogTitle: '选择供应商',
      name: '供应商名称',
      master: '联系人',
      phone: '联系电话',
      email: '邮箱'
    },
    publicPurchaseSign: '采购门户',
    publicPurchaseSignOptions: {
      'Y': '公开到我的采购门户',
      'N': '不公开到我的采购门户'
    },
    parityType: '比价方式',
    parityTypeOptions: {
      '1': '密封比价',
      '0': '非密封比价'
    },
    contactType: '联系方式',
    contactName: '联系人名称',
    contactPhone: '联系电话',
    contactEmail: '联系邮箱',
    contactTypeOptions: {
      '1': '公开',
      '2': '授权后可见',
      '3': '报价后可见'
    },
    detail: '询价单详情'
  }
}
